import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ProductSection() {
  const tomos = [{
    emoji: '📘',
    title: 'Tomo 1 — El Código del Ardor',
    items: ['La hipoclorhidria, la menopausia, el H. pylori y el cardias que falla', 'Con 5 tests de autodiagnóstico', 'Plan de acción para los primeros 3 días'],
    color: 'border-blue-500/30'
  }, {
    emoji: '📗',
    title: 'Tomo 2 — Nutrición de Sellado',
    items: ['El Semáforo de la Acidez adaptado a Argentina', 'Los alimentos que sellan la mucosa', 'Los sustitutos inteligentes', 'La lista de compras para tu feria'],
    color: 'border-green-500/30'
  }, {
    emoji: '📙',
    title: 'Tomo 3 — El Escudo Nocturno',
    items: ['Posición lateral izquierda y cabecera elevada', 'Ritual de 10 minutos', 'Infusiones nocturnas', 'Las 7 palancas que cierran el cardias antes de apagar la luz'],
    color: 'border-orange-500/30'
  }, {
    emoji: '📕',
    title: 'Tomo 4 — Cocina de Alivio Frío',
    items: ['45 recetas de desayunos, almuerzos y cenas que no disparan el fuego', 'Ingredientes de cualquier super argentino', 'Ninguna toma más de 20 minutos'],
    color: 'border-red-500/30'
  }, {
    emoji: '📓',
    title: 'Tomo 5 — El Nerviosismo Gástrico',
    items: ['La conexión entre el estrés, el nervio vago y el cardias', 'Las 8 técnicas de activación vagal con evidencia', 'El Protocolo SOS para el ardor emocional'],
    color: 'border-gray-500/30'
  }, {
    emoji: '📔',
    title: 'Tomo 6 — El Mapa de la Libertad',
    items: ['La reintroducción del café, el mate y la copa de vino', 'El protocolo de reducción gradual del omeprazol con tu médico', 'El mantenimiento de 15 minutos diarios'],
    color: 'border-brand-gold/30'
  }];
  const includes = ['Plan diario listo para arrancar hoy mismo', 'Recetas con ingredientes de tu feria argentina', 'Semáforo de alimentos adaptado a Argentina', 'Tracker de síntomas con criterios de medición', 'Checklist imprimible por etapa', 'Bibliografía científica completa'];
  return <section className="py-24 bg-brand-dark" data-id="element-221">
      <div className="container mx-auto px-4" data-id="element-222">
        <div className="max-w-5xl mx-auto" data-id="element-223">
          <div className="text-center mb-16" data-id="element-224">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-225">
              <h2 className="text-4xl md:text-5xl font-bold mb-4 text-brand-gold font-[Poppins,_sans-serif]" data-id="element-226">
                🏆 SISTEMA ESCUDO GÁSTRICO™
              </h2>
              <p className="text-2xl text-white font-medium mb-2" data-id="element-227">
                6 Tomos + 6 Bonos — Sistema completo de 30 días
              </p>
              <p className="text-xl text-brand-light font-[600]" data-id="element-228">
                300+ páginas.
              </p>
            </motion.div>
          </div>

          <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-229">
            📚 6 TOMOS COMPLETOS
          </h3>

          <div className="grid gap-6 mb-16" data-id="element-230">
            {tomos.map((tomo, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`bg-brand-black p-6 md:p-8 rounded-2xl border ${tomo.color} flex flex-col md:flex-row gap-6 items-start hover:bg-gray-900/50 transition-colors`} data-id="element-231">
                <div className="text-5xl shrink-0" data-id="element-232">{tomo.emoji}</div>
                <div data-id="element-233">
                  <h4 className="text-xl font-bold text-white mb-3" data-id="element-234">
                    {tomo.title}
                  </h4>
                  <ul className="space-y-2" data-id="element-235">
                    {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300" data-id="element-236">
                        <CheckCircle2 className="w-5 h-5 text-brand-light shrink-0 mt-0.5" data-id="element-237" />
                        <span data-id="element-238">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-green/10 border border-brand-green/30 rounded-2xl p-8 md:p-10" data-id="element-239">
            <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-240">
              Cada tomo incluye:
            </h4>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-241">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-242">
                  <CheckCircle2 className="w-6 h-6 text-brand-light shrink-0" data-id="element-243" />
                  <span className="text-gray-200" data-id="element-244">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}